export const GENERAL_PER_PAGE = 10;

export const ADMIN_USERS_PER_PAGE = 100;
